const WEEKDAYS_LONG = {
  en: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  pl: [
    "Niedziela",
    "Poniedziałek",
    "Wtorek",
    "środa",
    "Czwartek",
    "Piątek",
    "Sobota"
  ]
};
const WEEKDAYS_SHORT = {
  en: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  pl: ["N", "Po", "Wt", "Sr", "Cz", "Pt", "So"]
};
const MONTHS = {
  en: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  pl: [
    "Styczeń",
    "Luty",
    "Marzec",
    "Kwiecień",
    "Maj",
    "Czerwiec",
    "Lipiec",
    "Sierpień",
    "Wrzesień",
    "Październik",
    "Listopad",
    "Grudzień"
  ]
};
export const localeCustomUtils = {
  formatMonthTitle(d, locale) {
    return `${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`;
  },
  formatWeekdayShort(i, locale) {
    return WEEKDAYS_SHORT[locale][i];
  },
  formatWeekdayLong(i, locale) {
    return WEEKDAYS_LONG[locale][i];
  },
  getFirstDayOfWeek(locale) {
    if (locale === "pl") {
      return 1;
    }
    return 0;
  }
};



// WEBPACK FOOTER //
// ./src/browser/lib/LocaleUtilisPl.js